<!-- Card -->
<a class="card card-hover-shadow h-100" href="#">
  <div class="card-body">
    <h6 class="card-subtitle">{{ title }}</h6>

    <div class="row align-items-center gx-2 mb-1">
      <div class="col-6">
        <h2 class="card-title text-inherit">{{ currentPeriodValue }}</h2>
      </div>
      <!-- End Col -->

      <div class="col-6">
        <!-- Chart -->
        <div class="chartjs-custom" style="height: 3rem;">
          <canvas class="js-chart" data-hs-chartjs-options="{
                              &quot;type&quot;: &quot;line&quot;,
                              &quot;data&quot;: {
                                 &quot;labels&quot;: [&quot;1 May&quot;,&quot;2 May&quot;,&quot;3 May&quot;,&quot;4 May&quot;,&quot;5 May&quot;,&quot;6 May&quot;,&quot;7 May&quot;,&quot;8 May&quot;,&quot;9 May&quot;,&quot;10 May&quot;,&quot;11 May&quot;,&quot;12 May&quot;,&quot;13 May&quot;,&quot;14 May&quot;,&quot;15 May&quot;,&quot;16 May&quot;,&quot;17 May&quot;,&quot;18 May&quot;,&quot;19 May&quot;,&quot;20 May&quot;,&quot;21 May&quot;,&quot;22 May&quot;,&quot;23 May&quot;,&quot;24 May&quot;,&quot;25 May&quot;,&quot;26 May&quot;,&quot;27 May&quot;,&quot;28 May&quot;,&quot;29 May&quot;,&quot;30 May&quot;,&quot;31 May&quot;],
                                 &quot;datasets&quot;: [{
                                  &quot;data&quot;: [21,20,24,20,18,17,15,17,18,30,31,30,30,35,25,35,35,40,60,90,90,90,85,70,75,70,30,30,30,50,72],
                                  &quot;backgroundColor&quot;: [&quot;rgba(55, 125, 255, 0)&quot;, &quot;rgba(255, 255, 255, 0)&quot;],
                                  &quot;borderColor&quot;: &quot;#377dff&quot;,
                                  &quot;borderWidth&quot;: 2,
                                  &quot;pointRadius&quot;: 0,
                                  &quot;pointHoverRadius&quot;: 0
                                }]
                              },
                              &quot;options&quot;: {
                                 &quot;scales&quot;: {
                                   &quot;y&quot;: {
                                     &quot;display&quot;: false
                                   },
                                   &quot;x&quot;: {
                                     &quot;display&quot;: false
                                   }
                                 },
                                &quot;hover&quot;: {
                                  &quot;mode&quot;: &quot;nearest&quot;,
                                  &quot;intersect&quot;: false
                                },
                                &quot;plugins&quot;: {
                                  &quot;tooltip&quot;: {
                                    &quot;postfix&quot;: &quot;k&quot;,
                                    &quot;hasIndicator&quot;: true,
                                    &quot;intersect&quot;: false
                                  }
                                }
                              }
                            }" width="174" height="96"
                  style="display: block; box-sizing: border-box; height: 48px; width: 87px;">
          </canvas>
        </div>
        <!-- End Chart -->
      </div>
      <!-- End Col -->
    </div>
    <!-- End Row -->


    <span class="badge"
          [class.bg-soft-success]="trendSentiment === 'positive'"
          [class.text-success]="trendSentiment === 'positive'"
          [class.bg-soft-dark]="trendSentiment === 'neutral'"
          [class.text-dark]="trendSentiment === 'neutral'"
          [class.bg-soft-danger]="trendSentiment === 'negative'"
          [class.text-danger]="trendSentiment === 'negative'"
    >
                @if (trendDirection === "up") {
                  <i class="bi-graph-up"></i>
                } @else if (trendDirection === "down") {
                  <i class="bi-graph-down"></i>
                } {{ percentageDifference }}
              </span>
    <span class="text-body fs-6 ms-1">from {{ previousPeriodValue }}</span>
  </div>
</a>
<!-- End Card -->
